export const SESSION_ACTION_LIST = 'playerMessagesActionList';

export const urlMapping = {
  MEDDELANDE: '/meddelande-nova',
  KYC_ANSWER: '/meddelande-nova/kyc/svara',
  TRINIDAD_MEDDELANDE: '/meddelande',
  CUSTOMER_SERVICE_CONTACT: '/kundservice',
  GAMING_RESPONSIBILITY_PAUSE: '/spelpaus',
  CARETECH: '/spelansvar',
  MY_PROFILE_CHANGE_EMAIL: '/min-profil/uppgifter/epost',
  MY_PROFILE_CHANGE_CELLPHONE: '/min-profil/uppgifter/mobil',
  MY_PROFILE_DETAILS: '/min-profil/uppgifter',
  MY_PROFILE_VERIFY_EMAIL: '/min-profil/uppgifter/bekrafta-epost',
  MY_PROFILE_VERIFY_CELLPHONE: '/min-profil/uppgifter/bekrafta-mobil',
  MY_GAMING_RESPONSIBILITY: 'https://svenskaspel.gamtest.se/turspel',
} as const;

export const mainBlacklist = [
  /^\/$/,
  /^\/ft\/switchboard$/,
  /^\/ops\/styleguide(\/|$)/,
  /^\/styleguide(\/|$)/,
  /^\/spelpaus(\/|$)/,
  /^\/spelkoll$/,
  /^\/admin(\/|$)/,
  /^\/min-profil(\/|$)/,
  /^\/meddelande(\/|$)/,
  /^\/meddelande-nova(\/|$)/,
  /^\/skapa-inloggning(\/|$)/,
  /^\/player-messages\/blacklist$/,
  /^\/player-messages\/player-exclusions$/,
  /^\/player-messages\/pause24$/,
  /^\/real-time-messages(\/|$)/,
  /^\/villkor-och-integritet(\/|$)/,
  /^\/villkor-och-integritet-nova(\/|$)/,
] as const;

export const verticals = {
  ALL: 'all',
  QUICK_GAMES: 'quickGames',
} as const;

export const playerExclusionCanPlayResult = {
  dialogConfig: null,
  errorCode: null,
  errorId: null,
} as const;

export const exclusionMessageProducerIds = {
  dayTimeLimit: 'DAY_TIME_LIMIT',
  selfSuspension: 'SELF_SUSPENSION',
  nationalSuspension: 'NATIONAL_SUSPENSION',
} as const;

export const navigationMessageProducerIds = {
  contactVerification: 'CONTACT_VERIFICATION',
} as const;

export const contactInfoStatus = {
  deleted: '0',
  bounce: '1',
  verified: '2',
  offeredVerificationActive: '3',
  notOfferedVerification: '4',
  offeredVerificationExpired: '5',
} as const;

export type ContactInfoStatus = (typeof contactInfoStatus)[keyof typeof contactInfoStatus];

export const SESSION_CONTACT_VERIFICATION_DISMISSED = 'playerNotifs_remindLater';
export const SESSION_CONTACT_VERIFICATION_STATUS = 'playerNotifs_customerSettings';

export const ApiErrorMessageId = {
  TT: 'TT',
  NETTO_LOSS: 'NETTO_LOSS',
  TT_OR_NETTO_LOSS: 'TT_OR_NETTO_LOSS',
} as const;

export type ExclusionMessageProducerId = (typeof exclusionMessageProducerIds)[keyof typeof exclusionMessageProducerIds];
export type ApiErrorMessageId = (typeof ApiErrorMessageId)[keyof typeof ApiErrorMessageId];

export type PlayerExclusionCanPlayResult = typeof playerExclusionCanPlayResult & {
  errorObj?: null | object;
};
export type Vertical = (typeof verticals)[keyof typeof verticals];
